import { LOGO_URL, BRAND, NAV_LINKS } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white pt-20 pb-8 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-neutral-800">
          <div className="lg:col-span-5">
            <div className="bg-white inline-block p-3">
              <img
                src={LOGO_URL}
                alt="Rosenberg Objektservice"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="mt-6 text-neutral-400 leading-relaxed max-w-sm">
              Ihr Makler in Südhessen, der mit anpackt. Vermittlung, Betreuung,
              Pflege — aus einer Hand.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#8A151B] mb-5">
              Navigation
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-neutral-300 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#8A151B] mb-5">
              Kontakt
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="text-neutral-300 hover:text-white transition-colors"
                >
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${BRAND.phoneIntl}`}
                  className="text-neutral-300 hover:text-white transition-colors"
                >
                  {BRAND.phone}
                </a>
              </li>
              <li className="text-neutral-300">Südhessen, Deutschland</li>
            </ul>
          </div>
        </div>

        <div className="pt-12 pb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 text-xs uppercase tracking-wider text-neutral-500">
          <p>© {new Date().getFullYear()} Rosenberg Objektservice · Marc Rosenberg</p>
          <div className="flex gap-8">
            <a href="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum-link">
              Impressum
            </a>
            <a href="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-datenschutz-link">
              Datenschutz
            </a>
          </div>
        </div>

        {/* Giant brand wordmark */}
        <div className="-mb-8 lg:-mb-16 pointer-events-none select-none">
          <p className="font-display font-black tracking-tighter text-white/[0.04] text-[20vw] leading-[0.8] uppercase whitespace-nowrap text-center">
            Rosenberg
          </p>
        </div>
      </div>
    </footer>
  );
}
